import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password] as const

export type usrdCredType = (typeof credentialTypes)[number]
export const usrdDocumentTypes = [
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const usrd: CarrierDef<usrdCredType> = {
  name: 'US Road Freight Express',
  scac: 'usrd',
  credentialTypes,
  legacyCredMap: [...userPassMap],
  engineLayers: ['rating', 'pickup', 'tracking', 'profinder', 'documents'],
  documentTypes: usrdDocumentTypes,
}
